import { Modal, Carousel, Row, Col } from "antd";
import * as React from "react";
import FreeOrgAdminForm from "../../forms/FreeOrgAdminForm/FreeOrgAdminForm";
import "./LeftBanner.css";

import AnuvadakLogo from "../../../assets/images/anuvadak-login-logo.png";
import BengaliCharacter from "../../../assets/Icons/bengali.svg";
import OdiaCharacter from "../../../assets/Icons/odia.svg";
import TeluguCharacter from "../../../assets/Icons/telugu.svg";
import GujaratiCharacter from "../../../assets/Icons/gujarati.svg";
import HindiCharacter from "../../../assets/Icons/hindi.svg";
import MalayalamCharacter from "../../../assets/Icons/malayalam.svg";

const contentStyle = {
  margin: 0,
  height: "30vh",
};

const svgUrl = "https://avtstagecdn.blob.core.windows.net/static/svg";
const movingImages = () => {
  return (
    <>
      <img
        className={"position-absolute lang-svg-transition animated fadeIn"}
        style={{
          left: "5%",
          top: "14%",
        }}
        src={BengaliCharacter}
        alt="lang"
      />

      <img
        className={"position-absolute lang-svg-transition animated fadeIn"}
        style={{
          left: "30%",
        }}
        src={OdiaCharacter}
        alt="lang"
      />

      <img
        className={"position-absolute lang-svg-transition animated fadeIn"}
        style={{
          left: "15%",
          top: "90%",
        }}
        src={TeluguCharacter}
        alt="lang"
      />

      <img
        className={"position-absolute lang-svg-transition animated fadeIn"}
        style={{
          left: "55%",
          top: "4%",
        }}
        src={GujaratiCharacter}
        alt="lang"
      />

      <img
        className={"position-absolute lang-svg-transition animated fadeIn"}
        style={{
          left: "50%",
          top: "80%",
        }}
        src={HindiCharacter}
        alt="lang"
      />

      <img
        className={"position-absolute lang-svg-transition animated fadeIn"}
        style={{
          left: "80%",
          top: "70%",
        }}
        src={MalayalamCharacter}
        alt="lang"
      />
    </>
  );
};

const randomMovement = (event) => {
  const imageElements = Array.from(
    document.getElementsByClassName("lang-svg-transition")
  );
  const translateX = `${Math.random() * 100}px`;
  const translateY = `${Math.random() * 90}px`;
  const scale = 1 + Math.random() * 0.14;
  const mouseX = event.pageX;
  const mouseY = event.pageY;

  for (const image of imageElements) {
    const img = image;
    // calculate the image's center coordinates
    const imageCenterX = img.offsetLeft + img.offsetWidth / 2;
    const imageCenterY = img.offsetTop + img.offsetHeight / 2;
    // calculate the euclidean distance
    const distance = Math.sqrt(
      Math.pow(imageCenterX - mouseX, 2) + Math.pow(imageCenterY - mouseY, 2)
    );
    if (distance <= 120) {
      img.style.transform = `translate(${translateX},${translateY}) scale(${scale},${scale})`;
    }
  }
};

function LeftBanner(props) {
  const { freeTrial } = props;
  return (
    <div className="banner flex-column" onMouseMove={randomMovement}>
      {!freeTrial && movingImages()}
      <div
        className={"login-logo"}
        style={{
          display: "flex",
          justifyContent: freeTrial ? "center" : "flex-start",
          position: "fixed",
        }}
      >
        <img
          src={AnuvadakLogo}
          height={30}
          id="login-logo"
          alt="anuvadak-logo"
        />
      </div>
      {freeTrial ? (
        <div
          className="flex-column tutu banner-text"
          style={{ width: "95vw" }}
        ></div>
      ) : (
        <div className="flex-column tutunot banner-text" style={{ zIndex: 10 }}>
          <div className="banner-heading">
            Accelerate website & Mobile localization with Anuvadak now{" "}
            <span className="blinker">_</span>
          </div>
          <div className="banner-sub-heading">
            Launch multilingual website faster with minimal developer
            involvement Easily translate and manage translated content in one
            place
          </div>
          {/* <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className="banner-main-content-box">
                <div className="banner-main-content-head-box">
                  <span className="banner-main-content-head">
                    Benefits of Choosing Anuvadak for Website Localisation
                  </span>
                </div>
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div style={{ width: "50rem", padding: "29px" }}>
                <Carousel
                  autoplay={{
                    dotDuration: true,
                  }}
                  autoplaySpeed={3000}
                  style={{ zIndex: -1000 }}
                >
                  <div>
                    <Row className="carousel-inner-box">
                      <Col xs={24} sm={24} md={24} lg={24} xl={16}>
                        <h3 style={{ color: "#2b6e99" }}>Translate</h3>
                        <p className="carousel-text">
                          Anuvadak revolutionizes website translation with its
                          Indian language-specific neural machine translation
                          engine, expediting website deployment. Through
                          continuous localisation, newly added content on the
                          source English website is automatically translated and
                          updated on localized sites. This ensures regional
                          users consistently access the latest content in their
                          language. Anuvadak effortlessly integrates new content
                          by detecting and sending it for translator review,
                          maintaining a current and coherent multilingual web
                          presence.
                        </p>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} xl={8}>
                        <img
                          src="https://cdn-ilcjfmf.nitrocdn.com/kKanhwyDRGFNZICqzbzKkAJaIQuVJaYh/assets/images/optimized/rev-caca92e/reverieinc.com/wp-content/uploads/2024/01/030123-Reverie-Graphics-Anuvadak-02.png"
                          style={{
                            objectFit: "cover",
                          }}
                          width={300}
                          height={200}
                          alt="Anuvadak"
                        />
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <Row className="carousel-inner-box">
                      <Col xs={24} sm={24} md={24} lg={24} xl={16}>
                        <h3 style={{ color: "#2b6e99" }}>Manage</h3>
                        <p className="carousel-text">
                          Anuvadak consolidates the localization process,
                          eliminating the need for separate infrastructure and
                          content management, reducing complexity and costs. It
                          empowers businesses to efficiently manage projects,
                          enabling tasks like adding subdomains, adjusting
                          settings, and overseeing the entire project. It
                          resolves the challenge of tracking and managing
                          localization post-deployment, ensuring version control
                          is maintained. It benefits businesses with cost
                          savings, streamlined operations, enhanced control over
                          projects, and improved user experience.
                        </p>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} xl={8}>
                        <img
                          src="https://cdn-ilcjfmf.nitrocdn.com/kKanhwyDRGFNZICqzbzKkAJaIQuVJaYh/assets/images/optimized/rev-caca92e/reverieinc.com/wp-content/uploads/2024/02/Reverie-Graphics-Anuvadak-Manage-2048x2048-1-1024x1024.png"
                          style={{
                            objectFit: "cover",
                          }}
                          width={300}
                          height={200}
                          alt="Anuvadak"
                        />
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <Row className="carousel-inner-box">
                      <Col xs={24} sm={24} md={24} lg={24} xl={16}>
                        <h3 style={{ color: "#2b6e99" }}>Analytics</h3>
                        <p className="carousel-text">
                          Anuvadak’s analytics dashboard offers customers a
                          comprehensive toolkit for enhancing website
                          localization and user engagement. With features such
                          as site visits analysis, efficient project management,
                          language progress tracking, and page views
                          measurement, users gain valuable insights and control
                          over their multilingual content, enabling data-driven
                          decisions and fostering business growth.
                        </p>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} xl={8}>
                        <img
                          src="https://cdn-ilcjfmf.nitrocdn.com/kKanhwyDRGFNZICqzbzKkAJaIQuVJaYh/assets/images/optimized/rev-caca92e/reverieinc.com/wp-content/uploads/2024/02/Reverie-Graphics-Anuvadak-Analytics.png"
                          style={{
                            objectFit: "cover",
                          }}
                          width={300}
                          height={200}
                          alt="Anuvadak"
                        />
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <Row className="carousel-inner-box">
                      <Col xs={24} sm={24} md={24} lg={24} xl={16}>
                        <h3 style={{ color: "#2b6e99" }}>Automation</h3>
                        <p className="carousel-text">
                          Anuvadak’s automation processes offer businesses a
                          streamlined and efficient approach to content
                          management, eliminating the need for manual string
                          synchronization and enhancing data-driven
                          decision-making through analytics and Localized Page
                          Previews. Continuous Localization Support and
                          Auto-update of Localized Content ensure websites
                          remain up-to-date in multiple languages, fostering
                          competitiveness. Real-time progress tracking of
                          translation services adds transparency, empowering
                          businesses to effectively monitor and manage projects,
                          resulting in time savings, reduced manual effort, and
                          an enhanced online presence.
                        </p>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} xl={8}>
                        <img
                          src="https://cdn-ilcjfmf.nitrocdn.com/kKanhwyDRGFNZICqzbzKkAJaIQuVJaYh/assets/images/optimized/rev-caca92e/reverieinc.com/wp-content/uploads/2023/12/Reverie-Graphics-Anuvadak-Automated-1024x1024.png"
                          style={{
                            objectFit: "cover",
                          }}
                          width={300}
                          height={200}
                          alt="Anuvadak"
                        />
                      </Col>
                    </Row>
                  </div>
                </Carousel>
              </div>
            </Col>
          </Row> */}
        </div>
      )}
      {freeTrial && (
        <div style={{ borderRadius: "10%" }}>
          <Modal
            visible={true}
            footer={null}
            closable={false}
            mask={false}
            width={600}
            // height={700}
            className="free-trial-modal"
            // centered
          >
            <FreeOrgAdminForm />
          </Modal>
        </div>
      )}
    </div>
  );
}

export default LeftBanner;
